/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "./type";
/**
 * @hidden
 */
var EventProxy = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(EventProxy, _super);
    function EventProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseWheel = null;
        _this.onMouseWheelHorizontal = null;
        _this.onPinchStarted = null;
        _this.onPinchDelta = null;
        _this.onGestureCompleted = null;
        _this.onZoomStarted = null;
        _this.onZoomDelta = null;
        _this.onZoomCompleted = null;
        _this.onFlingStarted = null;
        _this.onContactStarted = null;
        _this.onDragStarted = null;
        _this.onContactMoved = null;
        _this.onDragDelta = null;
        _this.onContactCompleted = null;
        _this.onDragCompleted = null;
        _this.onMouseLeave = null;
        _this.onMouseOver = null;
        _this.onMouseEnter = null;
        _this.onMouseDown = null;
        _this.onMouseUp = null;
        _this.onDoubleTap = null;
        _this.onHold = null;
        _this.onKeyDown = null;
        _this.onKeyUp = null;
        _this.bg = null;
        _this.bd = 0;
        _this.ai = false;
        _this.aj = false;
        _this.al = null;
        _this.an = null;
        _this.ao = null;
        _this.ap = null;
        _this.z = false;
        _this.aa = false;
        _this.am = null;
        return _this;
    }
    EventProxy.prototype.ab = function (a, b, c) {
        if (this.an != null) {
            return this.an(a, b, c);
        }
        return this.al(a);
    };
    EventProxy.prototype.get_ak = function () {
        return false;
    };
    Object.defineProperty(EventProxy.prototype, "ak", {
        get: function () {
            return this.get_ak();
        },
        enumerable: true,
        configurable: true
    });
    EventProxy.prototype.ag = function (a, b) {
        if (this.onMouseWheel != null && !this.ac) {
            return this.onMouseWheel(a, b);
        }
        return false;
    };
    EventProxy.prototype.ah = function (a, b) {
        if (this.onMouseWheelHorizontal != null && !this.ac) {
            return this.onMouseWheelHorizontal(a, b);
        }
        return false;
    };
    EventProxy.prototype.a8 = function (a, b) {
        if (this.onPinchStarted != null && !this.ac) {
            this.onPinchStarted(a, b);
        }
    };
    EventProxy.prototype.bb = function (a, b, c, d) {
        if (this.onZoomStarted != null && !this.ac) {
            this.onZoomStarted(a, b, c, d);
        }
    };
    EventProxy.prototype.ad = function (a, b, c) {
        if (this.onFlingStarted != null && !this.ac) {
            return this.onFlingStarted(a, b, c);
        }
        return true;
    };
    EventProxy.prototype.a7 = function (a, b) {
        if (this.onPinchDelta != null && !this.ac) {
            this.onPinchDelta(a, b);
        }
    };
    EventProxy.prototype.ba = function (a, b, c, d) {
        if (this.onZoomDelta != null && !this.ac) {
            this.onZoomDelta(a, b, c, d);
        }
    };
    EventProxy.prototype.a9 = function (a, b, c, d) {
        if (this.onZoomCompleted != null && !this.ac) {
            this.onZoomCompleted(a, b, c, d);
        }
    };
    EventProxy.prototype.a0 = function (a, b) {
        if (this.onGestureCompleted != null && !this.ac) {
            this.onGestureCompleted(a, b);
        }
    };
    EventProxy.prototype.av = function (a, b) {
        if (this.onContactStarted != null && !this.ac) {
            this.onContactStarted(a, b);
        }
    };
    EventProxy.prototype.az = function (a) {
        if (this.onDragStarted != null && !this.ac) {
            this.onDragStarted(a);
        }
    };
    EventProxy.prototype.au = function (a, b) {
        if (this.onContactMoved != null && !this.ac) {
            this.onContactMoved(a, b);
        }
    };
    EventProxy.prototype.ay = function (a) {
        if (this.onDragDelta != null && !this.ac) {
            this.onDragDelta(a);
        }
    };
    EventProxy.prototype.at = function (a, b, c) {
        if (this.onContactCompleted != null && !this.ac) {
            this.aj = c;
            this.onContactCompleted(a, b);
            this.aj = false;
        }
    };
    EventProxy.prototype.ax = function (a) {
        if (this.onDragCompleted != null && !this.ac) {
            this.onDragCompleted(a);
        }
    };
    EventProxy.prototype.a4 = function (a) {
        if (this.onMouseLeave != null && !this.ac) {
            this.onMouseLeave(a);
        }
    };
    EventProxy.prototype.a5 = function (a, b, c) {
        if (this.onMouseOver != null && !this.ac) {
            this.onMouseOver(a, b, c);
        }
    };
    EventProxy.prototype.a3 = function (a) {
        if (this.onMouseEnter != null && !this.ac) {
            this.onMouseEnter(a);
        }
    };
    EventProxy.prototype.a2 = function (a) {
        if (this.onMouseDown != null && !this.ac) {
            this.onMouseDown(a);
        }
    };
    EventProxy.prototype.a6 = function (a) {
        if (this.onMouseUp != null && !this.ac) {
            this.onMouseUp(a);
        }
    };
    EventProxy.prototype.ae = function (a) {
        if (this.onKeyDown != null && !this.ac) {
            return this.onKeyDown(a);
        }
        return false;
    };
    EventProxy.prototype.af = function (a) {
        if (this.onKeyUp != null && !this.ac) {
            return this.onKeyUp(a);
        }
        return false;
    };
    EventProxy.prototype.aw = function (a) {
        if (this.onDoubleTap != null && !this.ac) {
            this.onDoubleTap(a);
        }
    };
    EventProxy.prototype.a1 = function (a) {
        if (this.onHold != null && !this.ac) {
            this.onHold(a);
        }
    };
    Object.defineProperty(EventProxy.prototype, "ac", {
        get: function () {
            return this.z;
        },
        set: function (a) {
            this.z = a;
            this.as();
        },
        enumerable: true,
        configurable: true
    });
    EventProxy.prototype.as = function () {
    };
    EventProxy.$t = markType(EventProxy, 'EventProxy');
    return EventProxy;
}(Base));
export { EventProxy };
//# sourceMappingURL=EventProxy.js.map
